import constants from "../../../../../../appConstants";
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { driverValueGetter } from "../utils";
import { CustomerNameCellRenderer } from "../../../../../common/CustomerMergeIndicator/CustomerNameCell";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration(config);
  }

  static getDefaultConfiguration(_config) {
    return {
      keyColumn: "",
      rowSelection: "multiple",
      rowDeselection: true,
      suppressRowTransform: true,
      defaultColDef: {
        lockPinned: true,
        editable: false,
        lockPosition: true,
      },
      columns: [
        {
          headerName: "Pro#",
          field: "proNumber",
          headerTooltip: "Pro Number",
          minWidth: constants.columnWidth.W_130,
          maxWidth: constants.columnWidth.W_130,
          cellClass: "gridCell-leftAlign",
          pinned: "left",
          lockPosition: true,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: "Customer",
          field: "displayCustomerName",
          headerTooltip: "Customer Name",
          width: constants.columnWidth.CUSTOMER_CODE,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          cellRenderer: CustomerNameCellRenderer,
        },
        {
          headerName: "City",
          field: "city",
          headerTooltip: "City",
          width: constants.columnWidth.CITY,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          tooltipField: "city",
        },
        {
          headerName: "Return Code",
          minWidth: constants.columnWidth.W_110,
          maxWidth: constants.columnWidth.W_110,
          valueGetter: (params) => params.data.returnDetail.returnCode,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          headerTooltip: "Return Reason",
        },
        {
          headerName: "Driver",
          headerTooltip: "Driver Name",
          width: constants.columnWidth.DISPATCH_DRIVER_NAME,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          valueGetter: driverValueGetter,
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Arrival Time",
          field: "arrivalTime",
          headerTooltip: "Arrival Time",
          minWidth: constants.columnWidth.W_110,
          maxWidth: constants.columnWidth.W_110,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Departure Time",
          field: "departureTime",
          headerTooltip: "Departure Time",
          minWidth: constants.columnWidth.W_130,
          maxWidth: constants.columnWidth.W_130,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Contact Name",
          valueGetter: (params) => params.data.returnDetail.displayCustomerName,
          width: constants.columnWidth.CUSTOMER_NAME,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          headerTooltip: "Contact Name",
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Return Entered By",
          valueGetter: (params) => params.data.returnDetail.returnEnteredBy,
          width: constants.columnWidth.CUSTOMER_NAME,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          headerTooltip: "Return Entered By",
          tooltipValueGetter: (params) => params.value,
        },
      ],
    };
  }
}
